module.exports = __webpack_public_path__ + "img/vertical_3_7_3009.384ec24c.png";